import React from 'react'
import { observer } from 'mobx-react'
import SelectedToCollection from './SelectedToCollection'
import ForEachModel from '../collections/ForEachModel'

function SelectedModels (props) {
  return (
    <SelectedToCollection>
      <ForEachModel>
        {props.children}
      </ForEachModel>
    </SelectedToCollection>
  )
}

export default observer(SelectedModels)
